export const getSearchParams = (
  paramsCatalogue: {
    sortParams?: Record<string, string>;
    searchParams: Record<string, string>;
  },
  sortKey: string,
  searchKey: string,
  searchInput: string,
) => {
  const { sortParams, searchParams } = paramsCatalogue;
  //search
  const param = sortKey.length > 1 ? searchParams[searchKey]?.toLowerCase() : searchParams[searchKey];
  const filter = searchInput.trim();
  //sort
  const orderBy = sortParams?.[sortKey];

  const result: Record<string, string> = {};
  if (param && filter) {
    result[param] = filter;
  }
  if (orderBy) {
    result['orderBy'] = orderBy;
  }

  return result;
};

export const getValidMultiSearchParams = (
  paramsCatalogue: {
    sortParams?: Record<string, string>;
    searchParams: Record<string, string>;
  },
  searchParamsInputs: Record<string, string>,
  sortKey: string,
) => {
  const { sortParams, searchParams } = paramsCatalogue;
  const validParams: Record<string, string> = {};
  //search
  for (const [key, value] of Object.entries(searchParamsInputs)) {
    const param = searchParams[key];
    if (value && +value !== 0) {
      validParams[param] = value;
    }
  }
  //sort
  const orderBy = sortParams?.[sortKey];
  if (orderBy) {
    validParams['orderBy'] = orderBy;
  }

  return validParams;
};
